var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 408,
  height: 407,
  viewBox: "0 0 408 407",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.202683,
  d: "M10.125 193.197C15.7169 86.4973 106.988 4.54553 213.984 10.153C320.981 15.7604 403.185 106.804 397.593 213.504C392.001 320.204 300.73 402.155 193.734 396.548C86.7376 390.94 4.53305 299.897 10.125 193.197ZM45.1031 194.531C40.5344 281.706 107.696 356.089 195.114 360.671C282.531 365.252 357.1 298.297 361.669 211.122C366.237 123.947 299.075 49.5634 211.658 44.982C124.241 40.4007 49.6717 107.356 45.1031 194.531Z",
  fill: "url(#paint0_linear)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 407.662,
  y1: 21.375,
  x2: 1.41193,
  y2: 386.145,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B9B9B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.999789,
  stopColor: "white"
})))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circle.13c78072.svg";
export { ForwardRef as ReactComponent };